// extracted by mini-css-extract-plugin
export default {"FooterWrapper":"CustomFieldSelection_FooterWrapper__e49qQ"};